'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    // Log the error to an error reporting service
    console.error('App Error:', error);
    
    // TODO: Integrate with Sentry or similar
    // Sentry.captureException(error);
  }, [error]);

  return (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
      <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-10 w-10 text-destructive" />
      </div>
      
      <span className="from-foreground bg-gradient-to-b to-transparent bg-clip-text text-[6rem] leading-none font-extrabold text-transparent">
        500
      </span>
      
      <h2 className="font-heading my-2 text-2xl font-bold">
        Algo salió mal
      </h2>
      
      <p className="mb-2 text-muted-foreground">
        Ha ocurrido un error inesperado en la aplicación.
      </p>
      
      {error.digest && (
        <p className="mb-6 font-mono text-xs text-muted-foreground/60">
          Error ID: {error.digest}
        </p>
      )}
      
      <div className="mt-8 flex justify-center gap-2">
        <Button onClick={reset} variant="default" size="lg">
          <RefreshCw className="mr-2 h-4 w-4" />
          Reintentar
        </Button>
        <Button
          onClick={() => router.push('/dashboard')}
          variant="ghost"
          size="lg"
        >
          <Home className="mr-2 h-4 w-4" />
          Ir al inicio
        </Button>
      </div>
    </div>
  );
}
